export enum ParteDeVisitaState {
    Create = 0,
    Continue = 1,
    Validated = 2,
}
